<template>
	<SmartLink
		@click="handleClick"
		class="navbar__button__link navbar__button--jwtv"
		:class="{ 'nav-link-active': isActive }"
		:to="jwtvPath"
		data-testid="navbar-jwtv"
	>
		<span class="navbar__button__link__item navbar__button__link__item--jwtv">
			JustWatch TV
			<span class="navbar__button--jwtv__dot" v-if="startPageJwtvVariant === 'variant_1'" />
		</span>
	</SmartLink>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useStartPageJwtvExperiment } from '@/components/experiments/startPageJwtv';

const { webLocale, country } = storeToRefs(useLanguageStore());
const route = useRoute();

const jwtvPath = computed(() =>
	country.value === 'GB'
		? { name: 'app.titles.popular.provider', params: { provider: 'justwatchtv' } }
		: { name: 'app.jwtv.landing-page', path: `/${webLocale.value}/watch` }
);

const isActive = computed(() => route.name === 'app.jwtv.landing-page');

const { activeVariant: startPageJwtvVariant } = useStartPageJwtvExperiment();

function handleClick() {
	TrackingHelper.trackEvent(
		'userinteraction',
		{ action: 'tabchange', label: 'jwtv', useLastRoute: true },
		[],
		false,
		true
	);
}
</script>

<style lang="scss" scoped>
.navbar__button--jwtv__dot {
	display: inline-block;
	width: 6px;
	height: 6px;
	background: #e5001a;
	border-radius: 50%;
	margin-inline-start: 4px;
	flex-shrink: 0;
	align-self: center;
}

.navbar__button__link__item--jwtv {
	display: flex;
	align-items: center;
}
</style>
